/* eslint-disable */
import React, { Component } from 'react';
import {
  Alert,
  FormGroup,
  Button,
  Col,
  Label,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  Media,
  Row,
  Container,
  Form,
} from 'reactstrap';
import PropTypes from 'prop-types';
import extractIdData from '../../functions/extractIdData'
// import role from '../../../ProjectConfiguration/role.json';

class EditReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reviewLevel: 0,
      reportData: {},
      batchId: '',
      sysId: '',
      isConfirmed: true,
    };
    this.onCapIqrChange = this.onCapIqrChange.bind(this);
    this.onCapChange = this.onCapChange.bind(this);
    this.onIsmChange = this.onIsmChange.bind(this);
    this.onIsmIqrChange = this.onIsmIqrChange.bind(this);
    this.onIsmIqrPercentageChange = this.onIsmIqrPercentageChange.bind(this);
    this.onReportIdChange = this.onReportIdChange.bind(this);
    this.onBatchIdChange = this.onBatchIdChange.bind(this);
    this.onReviewLevelChange = this.onReviewLevelChange.bind(this);
    this.onSaveCangesClick = this.onSaveCangesClick.bind(this);
    this.onFindClick = this.onFindClick.bind(this);
  }

  componentWillReceiveProps(nextProp) {
    console.log('-------Component Will Recive Prop--------');
    console.log(nextProp);
    if (nextProp.editingReport && nextProp.editingReport.hasOwnProperty('batchId') && nextProp.editingReport.hasOwnProperty('sysId')) {
      this.setState({
        batchId: nextProp.editingReport.batchId,
        sysId: nextProp.editingReport.sysId,
      });

      if (nextProp.editingReport.reportData && nextProp.editingReport.reportData.id) {
        if (this.props.editingReport && (nextProp.editingReport.sysId !== this.props.editingReport.sysId)) {
            this.setState({
              reportData: nextProp.editingReport.reportData,
              batchId: nextProp.editingReport.batchId,
              sysId: nextProp.editingReport.sysId,
            });
        } else {
          this.setState({
            reportData: nextProp.editingReport.reportData,
            batchId: nextProp.editingReport.batchId,
            sysId: nextProp.editingReport.sysId,
          });
        }
      } else {
        this.setState({
          reportData: {
            id: '0',
            capIqr: 0,
            cap: 0,
            ism: 0,
            ismIqr: 0,
            ismIqrPercentage: 0,
            reportDate: nextProp.editingReport.reportDate,
          },
        });
      }
    } 
  }

  onReportIdChange(event){
    this.setState({
      reportData: {...this.state.reportData, id: event.target.value},
    });
  }

  onCapIqrChange(event) {
    this.setState({
      reportData: {...this.state.reportData, capIqr: parseInt(event.target.value)},
    });
  }

  onCapChange(event) {
    this.setState({
      reportData: {...this.state.reportData, cap: parseInt(event.target.value)},
    });
  }

  onIsmChange(event) {
    this.setState({
      reportData: {...this.state.reportData, ism: parseFloat(event.target.value).toFixed(1)},
    });
  }

  onIsmIqrChange(event) {
    this.setState({
      reportData: {...this.state.reportData, ismIqr: parseFloat(event.target.value).toFixed(1)},
    });
  }

  onIsmIqrPercentageChange(event) {
    this.setState({
      reportData: {...this.state.reportData, ismIqrPercentage: parseInt(event.target.value)},
    });
  }

  onBatchIdChange(event){
    this.setState({
      batchId:  event.target.value,
    });
  }

  onReviewLevelChange(event){
    this.setState({
      reviewLevel:  event.target.value,
    });
  }

  onSaveCangesClick(){
    let { reportData } = this.state;
    this.setState({isConfirmed: true});
    reportData = {...reportData, ...extractIdData(reportData.id)};
    this.props.actions.updateReport({
      batchId: this.state.batchId,
      sysId: this.state.sysId,
      reportData: reportData,
    });
  }

  onFindClick() {
    console.log(this.state.batchId, this.state.reviewLevel);
    this.setState({isConfirmed: false});
    this.props.actions.getEditingReport({
      batchId: this.state.batchId,
      reviewLevel: this.state.reviewLevel,
    });
  }

  render() {
    let {reportData} = this.state;
    console.log('STATE: ', this.state);
    return (
      <Container className='mt-3'>
        <Form inline>
          <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
            <Label for="exampleEmail" className="mr-sm-2">Batch ID</Label>
            <Input type="text" placeholder="Enter Batch Number" value={this.state.batchId} onChange={this.onBatchIdChange}/>
          </FormGroup>
          <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
            <Label for="examplePassword" className="mr-sm-2">Review Level</Label>
            <Input type="number" value={this.state.reviewLevel} onChange={this.onReviewLevelChange}/>
          </FormGroup>
          <Button color="primary" onClick={this.onFindClick} >Search</Button>
          <Button className="ml-3" disabled={this.state.isConfirmed} color="success" onClick={this.onSaveCangesClick}>Confirm Details</Button>
        </Form>
      {
        this.props.editingReport && this.props.editingReport.imageLink ?
            <Row className="mt-3">
              <Col md='9'>
                <img height='750' src={`https://s3.us-west-2.amazonaws.com/${this.props.editingReport.imageLink.Bucket}/${this.props.editingReport.imageLink.Key}`} />
              </Col>
              <Col md='3'>
                <Form>
                  <FormGroup>
                    <Label for="exampleEmail">Report ID</Label>
                    <Input type="text" className='font-weight-bold text-right' value={reportData.id} onChange={this.onReportIdChange}/>
                  </FormGroup>
                  <FormGroup>
                    <Label for="exampleEmail">CAP IQR</Label>
                    <Input type="number" className='font-weight-bold text-right' value={reportData.capIqr} onChange={this.onCapIqrChange}/>
                  </FormGroup>
                  <FormGroup>
                    <Label for="examplePassword">CAP (dB/m)</Label>
                    <Input type="number" className='font-weight-bold text-right' value={reportData.cap} onChange={this.onCapChange}/>
                  </FormGroup>
                  <FormGroup>
                    <Label for="examplePassword">ISM(KPa)</Label>
                    <Input type="number" className='font-weight-bold text-right' step="0.1" value={parseFloat(reportData.ism)} onChange={this.onIsmChange}/>
                  </FormGroup>
                  <FormGroup>
                    <Label for="exampleEmail">ISM IQR</Label>
                    <Input type="number" className='font-weight-bold text-right' step="0.1" value={parseFloat(reportData.ismIqr)} onChange={this.onIsmIqrChange}/>
                  </FormGroup>
                  <FormGroup>
                    <Label for="examplePassword">ISM IQR/med. (%)</Label>
                    <Input type="number" className='font-weight-bold text-right' value={reportData.ismIqrPercentage} onChange={this.onIsmIqrPercentageChange}/>
                  </FormGroup>
                </Form>
              </Col>
            </Row>
        : <Alert color="warning" className="mt-3" > Choose Report for edit </Alert>
      }
      </Container>
    );
  }
}
EditReport.defaultProps = {
  editingReport: null,
};
EditReport.propTypes = {
  editingReport: PropTypes.shape(),
  actions: PropTypes.shape({
    updateReport: PropTypes.func,
    getEditingReport: PropTypes.func,
  }),
};

export default EditReport;



// WEBPACK FOOTER //
// ./src/components/Reports/Edit.js